import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "paymentSummary" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "numbers" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "black" }
const _hoisted_7 = { class: "numbers" }
const _hoisted_8 = { class: "text black" }
const _hoisted_9 = { class: "numbers black" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_arrow-R" }, null, -1)
const _hoisted_11 = { class: "paymentValue" }
const _hoisted_12 = { class: "black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.invoice)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("payments.summary_of_payment")), 1)
        ]),
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("payments.invoice_number")), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("payments.amount_w_tax")), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.invoice.document_id), 1)
            ]),
            _createElementVNode("span", _hoisted_7, _toDisplayString((_ctx.invoice.amount / 10000).toLocaleString(_ctx.$i18n.locale, {
              maximumFractionDigits: 2,
            })) + " " + _toDisplayString(_ctx.invoice.currency), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_8, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("payments.for_payment")), 1)
            ]),
            _createElementVNode("span", _hoisted_9, [
              _createElementVNode("strong", null, _toDisplayString((_ctx.invoice.amount / 10000).toLocaleString(_ctx.$i18n.locale, {
                maximumFractionDigits: 2,
              })) + " " + _toDisplayString(_ctx.invoice.currency), 1)
            ])
          ])
        ]),
        _createElementVNode("button", {
          "event-name": "finishPaymentButton",
          "event-from": "/user/my-payments/invoices/*/payment",
          class: "defaultButton next mt-20",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.payment && _ctx.payment(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("payments.finish_payment")), 1),
          _hoisted_10
        ]),
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('previous'))),
          class: "cancel"
        }, _toDisplayString(_ctx.$t("payments.previous_step")), 1),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("payments.value_of_purchase")) + ": ", 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString((_ctx.invoice.amount / 10000).toLocaleString(_ctx.$i18n.locale, {
              maximumFractionDigits: 2,
            })) + " " + _toDisplayString(_ctx.invoice.currency), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}